const copyToClipboard = async ({ fields, data }) => {
  // create new array data of object which key is fields and value is data
  const newData = data.map((item) => {
    let newLine = "";
    for (let i = 0; i < fields.length; i++) {
      newLine += item[fields[i]] ?? "";
      if (i !== fields.length - 1) {
        newLine += "\t";
      }
    }
    return newLine;
  });

  const str = newData.join("\n");

  await navigator.clipboard.writeText(str);
};

export default copyToClipboard;
